import Game from '../../Game';

export function addDragonbonesResources(name: string, path: string): void {
    Game.resource.add(`${name}_skeleton_data`, `${path}${name}_ske.json`);
    Game.resource.add(`${name}_texture_data`, `${path}${name}_tex.json`);
    Game.resource.add(`${name}_texture`, `${path}${name}_tex.png`);
}

export async function awaitDragonbonesResources(name: string) {
    return Promise.all([
        Game.resource.wait(`${name}_skeleton_data`),
        Game.resource.wait(`${name}_texture_data`),
        Game.resource.wait(`${name}_texture`),
    ]);
}

export function areDBResourcesLoaded(name: string): boolean {
    return (
        Game.resource.existsAndLoaded(`${name}_skeleton_data`) &&
        Game.resource.existsAndLoaded(`${name}_texture_data`) &&
        Game.resource.existsAndLoaded(`${name}_texture`)
    );
}
